// src/hooks/usePageReady.js
import { useEffect } from "react";

const usePageReady = (onPageReady, delay = 1000) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onPageReady?.();
        }, delay);

        return () => clearTimeout(timer);
    }, []);
};

export default usePageReady;
